/**
 * Lazy Clarity event tracker.
 * Dynamically imports @microsoft/clarity only on first call,
 * so the SDK never enters the initial JS bundle.
 */
let clarityModule: typeof import("@microsoft/clarity") | null = null;
let loading: Promise<typeof import("@microsoft/clarity")> | null = null;

export function trackClarityEvent(eventName: string) {
    if (clarityModule) {
        clarityModule.default.event(eventName);
        return;
    }

    if (!loading) {
        loading = import("@microsoft/clarity").then((mod) => {
            clarityModule = mod;
            return mod;
        });
    }

    loading.then((mod) => {
        mod.default.event(eventName);
    });
}
